// extracted by mini-css-extract-plugin
export var label = "ButtonWithMenu-module--label--2mopr";
export var link = "ButtonWithMenu-module--link--1aZhM";
export var description = "ButtonWithMenu-module--description--25kJw";
export var fadeIn = "ButtonWithMenu-module--fadeIn--7MXZV";
export var title = "ButtonWithMenu-module--title--2mExX";
export var radio = "ButtonWithMenu-module--radio--2U7XO";